import { useEffect, useState } from "react";

export type BlogSlugPair = { slug: string; ptSlug?: string };

// The blog articles are several MB of text and must stay out of the main bundle (Workbox does not
// precache a file over 5 MiB, so a heavier main bundle cannot work offline). The language switcher
// only needs which English post has a Portuguese twin, and only on a blog URL, so it loads them here.
let cached: BlogSlugPair[] | undefined;
let loading: Promise<BlogSlugPair[]> | undefined;

function loadBlogSlugPairs(): Promise<BlogSlugPair[]> {
    if (!loading) {
        loading = import("../consts/blogPosts").then(
            (module) => {
                cached = (module.blogPosts as BlogSlugPair[]).map(({ slug, ptSlug }) => ({ slug, ptSlug }));
                return cached;
            },
            (error) => {
                loading = undefined;
                throw error;
            }
        );
    }
    return loading;
}

export function useBlogSlugPairs(needed: boolean): BlogSlugPair[] | undefined {
    const [pairs, setPairs] = useState(cached);

    useEffect(() => {
        if (!needed || pairs) return undefined;
        let current = true;
        loadBlogSlugPairs().then(
            (loaded) => {
                if (current) setPairs(loaded);
            },
            () => undefined
        );
        return () => {
            current = false;
        };
    }, [needed, pairs]);

    return pairs;
}
